import { configureStore } from '@reduxjs/toolkit';

import { baseApi } from '@/api/baseApi';
import '@/api/cacheLinks';

import { rootReducer } from './rootReducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    // RTK Query's middleware drives caching, invalidation, polling and automatic request
    // cancellation on unmount. Omitting it leaves the endpoints inert.
    getDefaultMiddleware().concat(baseApi.middleware),
  devTools: import.meta.env.DEV,
});

export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
